// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"bfd10b50","174":"6a9ccd54","185":"71575b9c","199":"2ded8590","223":"c02e6539","232":"dff92612","480":"1557c4ff","484":"c02ad08b","664":"f06e1d20","666":"d46baf37","832":"c4c76ba4","874":"0d098f9e"}[chunkId] + ".chunk.js";
};